class MerchantUser {
    /**
     * @param {CognitoUser} cognitoUser
     * @param {CognitoUserSession} session
     * @param {boolean} isConfirmed
     */
    constructor(cognitoUser, session, isConfirmed) {
        this.cognitoUser = cognitoUser;
        this.session = session;
        this.data = { isConfirmed };

        this.attributes = null;
    }

    /**
     * @returns string
     */
    getUsername() {
        return this.cognitoUser.username;
    }

    /**
     * @returns string
     */
    getEmail() {
        return this.isConfirmed
            ? this.getAttribute('email')
            : this.getUsername();
    }

    /**
     * @returns {Promise<string|null>}
     */
    getMerchantCode() {
        return this.isConfirmed
            ? this.getAttribute('custom:source_type')
            : Promise.resolve(null);
    }

    /**
     * @returns {boolean}
     */
    get isConfirmed() {
        return this.data.isConfirmed;
    }

    /**
     * @param {string} name
     * @returns {Promise<string>}
     */
    async getAttribute(name) {
        if (this.attributes === null) {
            this.attributes = await this._loadAttributes();
        }
        return this.attributes[name];
    }

    /**
     * @returns {Promise<null|*>}
     */
    async getAttributes() {
        if (this.attributes === null) {
            this.attributes = await this._loadAttributes();
        }

        return this.attributes;
    }

    /**
     * @returns {Object}
     * @private
     */
    async _loadAttributes() {
        const attributes = await new Promise((resolve, reject) => {
            return this.cognitoUser.getUserAttributes((error, result) => {
                if (error) {
                    reject(error);
                }
                resolve(result);
            });
        });

        const attributesMap = attributes.reduce((acc, element) => {
            acc[element.getName()] = element.getValue();
            return acc;
        }, {});

        return attributesMap;
    }
}
export default MerchantUser;
